import React, { useState } from 'react';
import { ReactComponent as MinusIcon } from '../../../assets/icon/minus.svg';
import { ReactComponent as PlusIcon } from '../../../assets/icon/plus.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/icon/delete.svg';

interface ItemCounterProps {
  count: number;
  initialCountItem: number;
  setCount: (count: number) => void;
  onDelete?: () => void;
  enabledIcon?: boolean;
}

const ItemCounter: React.FC<ItemCounterProps> = ({ count, setCount, initialCountItem, onDelete, enabledIcon = false }) => {
  const handleIncrement = () => {
    const newCount = count + 1;
    setCount(newCount);
  };

  const handleDecrement = () => {
    if (count === 1 && onDelete) {
      onDelete();
    } else {
      const newCount = count - 1;
      setCount(newCount);
    }
  };

  return (
    <div className="flex items-center gap-1">
      <button type="button" onClick={handleDecrement} className="w-[26px] h-[26px] rounded-lg border border-neutral-300 flex items-center justify-center">
        {count === 1 && !enabledIcon   ? (
          <DeleteIcon className="h-4 w-4" />
        ) : (
          <MinusIcon className="h-full w-full" />
        )}
      </button>
      <span className="px-2 text-center text-base font-semibold leading-6 text-gray-700">{count}</span>
      <button type="button" onClick={handleIncrement} className="w-[26px] h-[26px] rounded-lg border border-neutral-300">
        <PlusIcon className="h-full w-full" />
      </button>
    </div>
  );
};

export default ItemCounter;
